import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut } from "lucide-react";

export default function Navbar({ variant = "marketing" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className={`glass-nav sticky top-0 z-40`} data-testid="navbar">
      <div className="container-x flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-home">
          <img src="/logo-mark.png" alt="VidyaAI Study" className="w-8 h-8 rounded-lg object-contain" />
          <span className="font-display text-xl font-medium tracking-tight">VidyaAI Study</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-[#4A4640]">
          {variant === "marketing" && (
            <>
              <a href="/#features" className="hover:text-[#1A1713]" data-testid="nav-features">Features</a>
              <a href="/#how" className="hover:text-[#1A1713]" data-testid="nav-how">How it works</a>
              <a href="/#pricing" className="hover:text-[#1A1713]" data-testid="nav-pricing">Plans</a>
              <Link to="/demo" className="hover:text-[#1A1713]" data-testid="nav-demo">Demo</Link>
              <Link to="/blog" className="hover:text-[#1A1713]" data-testid="nav-blog">Blog</Link>
            </>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Link
                to={user.role === "institute_admin" ? "/institute" : user.role === "self_study_student" ? "/selfstudy" : user.role === "super_admin" ? "/admin" : "/student"}
                className="btn-app"
                data-testid="nav-dashboard"
              >
                Dashboard
              </Link>
              <button onClick={handleLogout} className="text-[#4A4640] hover:text-[#1A1713]" data-testid="nav-logout" aria-label="Logout">
                <LogOut size={18} strokeWidth={1.6} />
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm text-[#4A4640] hover:text-[#1A1713]" data-testid="nav-login">
                Login
              </Link>
              <Link to="/register" className="btn-primary" data-testid="nav-register">Get started</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
